
// function updateResults(filters) {
//   console.log('funzione in cui fare le chiamate ajax per ogni azione sui filtri');
//   console.log('updated results with filters: ' + filters);
// }


function initFilters() {

  if ($('.filter-select').length > 0) {

    $('.filter-select:not(.active) button').click(function() {

      var $this = $(this).parent('.filter-select');

      if ($this.children('.filter-select__options').length > 0) {

        if ($this.hasClass('filter-select--open')) {
          $this.removeClass('filter-select--open');
        } else {
          $('.filter-select').removeClass('filter-select--open');
          $this.addClass('filter-select--open');
        }
      }
    });

    $('.filters__entry--all > button').click(function() {
      console.log('pippo');
      var $this = $(this).parent('.filters__entry');
      if (!$this.hasClass('filters__entry--open')) {
        $('.filter-select').removeClass('filter-select--open');
      }
      $this.toggleClass('filters__entry--open');
    });

    // operazioni al click su un filtro

    $('.filter-select a[data-filter]').click(function(e) {
      e.preventDefault();

      var $this = $(this),
          value = $this.data('filter');

      $this.parents('.filter-select').data('selected', value).attr('data-selected', value);

      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.parents('.filter-select').data('selected', "").attr('data-selected', "");
      } else {
        $this.parents('ul').find('[data-filter]').removeClass('active');
        $this.addClass('active');
      }

      $this.parents('.filter-select').removeClass('filter-select--open');

    });


    $('.filters__current').on('click', '.remove', function() {
      var $tag = $(this).parents('.filters__active'),
          valueId = $tag.data('filter');

      $('.filter-select[data-selected="' + valueId + '"]').data('selected', "").attr('data-selected', "").find('a.active').removeClass('active');
      $tag.remove();

    });


    $('.filters__close').click(function() {
      $('.filters__entry--all').removeClass('filters__entry--open');
    });

  }

}



function stickyFilters() {
  // affix for sticky filters

  var $filtersSticky = $('.filters--sticky'),
      $filtersStickyStart = $('.filters-affix-start'),
      $filtersStickyEnd = $('.filters-affix-end'),
      $filtersWrapper = $filtersSticky.parent(),
      $header = $('.header'),
      scroll;

  if ($filtersSticky.length > 0) {

    setTimeout(function() {
      $filtersWrapper.height($filtersSticky.height());
    }, 100);

    $(window).resize(function() {
      $filtersWrapper.height($filtersSticky.height());
    });

    $(window).scroll(function() {
      scroll = $(window).scrollTop();
      if (scroll >= $filtersStickyStart.offset().top - $header.outerHeight()) {
        if ((scroll + $filtersSticky.outerHeight() >= $filtersStickyEnd.offset().top)) {
          $filtersSticky.removeClass('affix');
          $header.removeClass('header--filter-affixed');
        } else {
          $filtersSticky.addClass('affix');
          $header.addClass('header--filter-affixed');
        }

      } else {
        $filtersSticky.removeClass('affix');
        $header.removeClass('header--filter-affixed');
      }
    });

  }
}
